// Note: copied from https://www.w3schools.com/js/js_cookies.asp

/**
 * Cookies should only be used for debug purpose
 * @deprecated
 */
export function setCookie(name: string, value: string, seconds: number): void {
    const date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${name}=${value};${expires};path=/`;
}

/**
 * Cookies should only be used for debug purpose
 * @deprecated
 */
export function getCookie(name: string): string {
    const searchString = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let cookie of cookies) {
        while (cookie.startsWith(' ')) {
            cookie = cookie.substring(1);
        }

        if (cookie.startsWith(searchString)) {
            return cookie.substring(searchString.length, cookie.length);
        }
    }

    return '';
}